import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { PropsWithChildren } from 'react';
import styles from './ConsultationModal.module.scss';
interface CounselingCheckboxProps {
  readonly id: string;
  readonly name: string;
  readonly checked: boolean;
  readonly onChange: (checked: boolean) => void;
}
export default function CounselingCheckbox(t0) {
  const $ = _c(17);
  const {
    id,
    name,
    checked,
    onChange,
    children
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = e => onChange(e.target.checked);
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== checked || $[3] !== id || $[4] !== name || $[5] !== t1) {
    t2 = <input type="checkbox" id={id} name={name} checked={checked} onChange={t1} className={styles.input} />;
    $[2] = checked;
    $[3] = id;
    $[4] = name;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = `${styles.box} ${checked ? styles.boxChecked : ""}`;
  let t4;
  if ($[7] !== checked) {
    t4 = checked && <Image src="/cc/image/icon_check_secondary.png" alt="check" width={16} height={16} />;
    $[7] = checked;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== id || $[10] !== t3 || $[11] !== t4) {
    t5 = <label htmlFor={id} className={t3} aria-hidden="true">{t4}</label>;
    $[9] = id;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== children || $[14] !== t2 || $[15] !== t5) {
    t6 = <div className={styles.checkboxContainer}>{t2}{t5}{children}</div>;
    $[13] = children;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}